import { observer } from 'mobx-react';
import { FC } from 'react';
import { toJS } from 'mobx';
import Grid from '@material-ui/core/Grid';

import useStore from '@hooks/useStore';
import AccountsPayableCustomTools from '@components/AccountsPayableCustomTools';
import AccountsPayableGroupCustomTables from '@components/AccountsPayableGroupCustomTables';
import AccountsPayableCustomTable from '@components/AccountsPayableCustomTable';
import useStyles from './../styles';

export interface ICanceled {}

const Canceled: FC<ICanceled> = () => {
  const { accountsPayableLink } = useStore();
  const { accountsPayable, tools } = accountsPayableLink;
  const { getTotalAmount, getUnselectedIdsLength, canProcess, canNotProcess } = accountsPayable;
  const { toolsGroupBy } = tools;
  const css = useStyles();

  const rows = [...toJS(canProcess), ...toJS(canNotProcess)];

  return (
    <>
      <div className={css.canceledCard}>
        <div className={css.canceledContainerSubtitle}>
          <span className={css.canceledTitleStep}>Operación cancelada</span>
          <span className={css.canceledSubtitleStep}>
            Para iniciar una nueva operación, regresa a Netsuite y genera una nueva solicitud.
          </span>
        </div>
      </div>
      <div className={css.card}>
        <AccountsPayableCustomTools />
        {toolsGroupBy !== '' ? (
          <AccountsPayableGroupCustomTables
            hideEnhancedTableToolbar
            canSelect={false}
            toolBarTitle={'Validación de pagos'}
            rows={rows}
          />
        ) : (
          <AccountsPayableCustomTable
            isCanceled
            hideEnhancedTableToolbar
            canSelect={false}
            toolBarTitle={'Validación de pagos'}
            rows={rows}
          />
        )}
        <Grid container spacing={3} className={css.containerButtons} />
      </div>
    </>
  );
};

export default observer(Canceled);
